import { PlaySettings } from "../SoundCard";
import { Duration } from "./duration";

export const DEFAULT_SOUNDCARD_VOLUME: number = 50;
export const DEFAULT_SOUNDCARD_ENABLED: boolean = true;
export const DEFAULT_SOUNDCARD_PLAY_SETTINGS: PlaySettings = new PlaySettings(
    null,
    DEFAULT_SOUNDCARD_ENABLED,
    DEFAULT_SOUNDCARD_VOLUME,
);
export const WELL_KNOWN_AMBIENCE_DURATIONS: Map<string, Duration> = new Map([
    ["0s", Duration.fromSeconds(0)],
    ["1s", Duration.fromSeconds(1)],
    ["2s", Duration.fromSeconds(2)],
    ["5s", Duration.fromSeconds(5)],
    ["10s", Duration.fromSeconds(10)],
    ["15s", Duration.fromSeconds(15)],
    ["20s", Duration.fromSeconds(20)],
    ["30s", Duration.fromSeconds(30)],
    ["45s", Duration.fromSeconds(45)],
    ["1m", Duration.fromSeconds(1 * 60)],
    ["2m", Duration.fromSeconds(2 * 60)],
    ["5m", Duration.fromSeconds(5 * 60)],
    ["10m", Duration.fromSeconds(10 * 60)],
    ["20m", Duration.fromSeconds(20 * 60)],
    ["30m", Duration.fromSeconds(30 * 60)],
])